import * as React from 'react';
import { observer } from 'mobx-react';

// Styles
const s = require('./WebBrowserUnsupported.css');

// Props
interface IWebBrowserIsUnsupportedProps {}

// Component
@observer
export class WebBrowserIsUnsupported extends React.Component<IWebBrowserIsUnsupportedProps, {}> {
    public render() {
        return (
            <div className={s.container}>
                <h1>Web browser unsupported</h1>
                <h3>
                    {`Please update to the newest version of Edge, Chrome, Firefox, Safari or Opera ` +
                        `to be able to access the portal.`}
                </h3>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/unsupported/WebBrowserUnsupported.tsx